<template>
  <aside
    class="menu app-sidebar animated"
    :class="{ slideInLeft: show, slideOutLeft: !show }"
  >
    <p class="menu-label">
      {{ $t('shell.menu') }}
    </p>
    <ul class="menu-list">
      <li v-for="(item, index) in menu">
        <div v-if="(menuRoles[index].role & getLoggedUserRole()) > 0">
          <router-link
            :to="item.path"
            :exact="true"
            :aria-expanded="isExpanded(item) ? 'true' : 'false'"
            v-if="item.path"
            @click.native="toggle(index, item)"
          >
            <span class="icon is-small"><i :class="['fa', item.meta.icon]"></i></span>
            {{ item.meta && item.meta.labelTrans && $t(item.meta.labelTrans) || item.meta.label || item.name }}
            <span
              class="icon is-small is-angle"
              v-if="item.children && item.children.length"
            >
              <i class="fa fa-angle-down"></i>
            </span>
          </router-link>
          <a
            :aria-expanded="isExpanded(item)"
            v-else
            @click="toggle(index, item)"
          >
            <span class="icon is-small"><i :class="['fa', item.meta.icon]"></i></span>
            {{ item.meta.label || item.name }}
            <span
              class="icon is-small is-angle"
              v-if="item.children && item.children.length"
            >
              <i class="fa fa-angle-down"></i>
            </span>
          </a>

          <expanding v-if="item.children && item.children.length">
            <ul v-show="isExpanded(item)">
              <li
                v-for="subItem in item.children"
                v-if="subItem.path"
              >
                <router-link :to="generatePath(item, subItem)">
                  {{
                    subItem.meta && subItem.meta.labelTrans && $t(subItem.meta.labelTrans) || subItem.meta.label || subItem.name
                  }}
                </router-link>
              </li>
            </ul>
          </expanding>
        </div>
      </li>
    </ul>
  </aside>
</template>

<script>
import Expanding from 'vue-bulma-expanding'
import {mapActions, mapGetters} from 'vuex'

export default {

  components: {
    Expanding
  },

  props: {
    show: Boolean
  },

  data () {
    return {
      isReady: false,
      menuRoles: [
        {
          name: 'Сценарии',
          role: 63
        },
        {
          name: 'Рассылки',
          role: 63
        },
        {
          name: 'Ежедневные Рассылки',
          role: 63
        },
        {
          name: 'Лицевой счет',
          role: 63
        },
        {
          name: 'Аналитика затрат',
          role: 63
        },
        {
          name: 'Детализации',
          role: 63
        },
        {
          name: 'Уведомления',
          role: 63
        },
        {
          name: 'Архив рассылок',
          role: 15
        },
        {
          name: 'Пользователи',
          role: 15
        },
        {
          name: 'Настройка прав',
          role: 1
        },
        {
          name: 'Настройка приложения',
          role: 1
        }
      ]
    }
  },

  mounted () {
    let route = this.$route
    if (route.name) {
      this.isReady = true
      this.shouldExpandMatchItem(route)
    }
  },

  computed: mapGetters({
    menu: 'menuitems',
    loggedRole: 'loggedRole'
  }),

  methods: {
    ...mapActions([
      'expandMenu'
    ]),

    getLoggedUserRole () {
      console.log(this.loggedRole)
      return this.loggedRole
    },

    isExpanded (item) {
      return item.meta.expanded
    },

    toggle (index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      })
    },

    shouldExpandMatchItem (route) {
      let matched = route.matched
      let lastMatched = matched[matched.length - 1]
      let parent = lastMatched.parent || lastMatched
      const isParent = parent === lastMatched

      if (isParent) {
        const p = this.findParentFromMenu(route)
        if (p) {
          parent = p
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        })
      }
    },

    generatePath (item, subItem) {
      return `${item.component ? item.path + '/' : ''}${subItem.path}`
    },

    findParentFromMenu (route) {
      const menu = this.menu
      for (let i = 0, l = menu.length; i < l; i++) {
        const item = menu[i]
        const k = item.children && item.children.length
        if (k) {
          for (let j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item
            }
          }
        }
      }
    }
  },

  watch: {
    $route (route) {
      this.isReady = true
      this.shouldExpandMatchItem(route)
    }
  }

}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';
@import '~bulma/sass/utilities/mixins';

.app-sidebar {
  position: fixed;
  top: 50px;
  left: 0;
  bottom: 0;
  padding: 20px 0 50px;
  width: 200px;
  min-width: 45px;
  max-height: 100vh;
  height: calc(100% - 50px);
  z-index: 1024 - 1;
  background: #fff;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
  overflow-y: auto;
  overflow-x: hidden;

  @include mobile() {
    transform: translate3d(-180px, 0, 0);
  }

  .icon {
    vertical-align: baseline;
    &.is-angle {
      position: absolute;
      right: 10px;
      transition: transform 0.377s ease;
    }
  }

  .menu-label {
    padding-left: 5px;
  }

  .menu-list {
    li a {
      &[aria-expanded='true'] {
        .is-angle {
          transform: rotate(180deg);
        }
      }
    }

    li a + ul {
      margin: 0 10px 0 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?a4b1c4c8